module.exports = __webpack_public_path__ + "img/avataaars.fb594a8d.png";